import {
  Building2,
  ClipboardList,
  CreditCard,
  Sparkles,
  Receipt,
  ShieldCheck,
} from "lucide-react";
import { createListCollection } from "@chakra-ui/react";

export const STEPS = [
  {
    id: 1,
    title: "Información básica",
    subtitle: "Nombre comercial, ERP y tamaño de tu operación",
    eyebrow: "Contexto operativo",
    icon: ClipboardList,
  },
  {
    id: 2,
    title: "Perfil comercial",
    subtitle: "Datos legales del comercio",
    eyebrow: "Base legal",
    icon: Building2,
  },
  {
    id: 3,
    title: "Recaudo",
    subtitle: "Modelo financiero y cuenta de dispersión",
    eyebrow: "Configuración financiera",
    icon: CreditCard,
  },
  {
    id: 4,
    title: "Experiencia",
    subtitle: "Marca, canales de atención y beneficios",
    eyebrow: "Personalización",
    icon: Sparkles,
  },
  {
    id: 5,
    title: "Facturación",
    subtitle: "Destinatarios administrativos y notificaciones",
    eyebrow: "Administración",
    icon: Receipt,
  },
  {
    id: 6,
    title: "Documentación",
    subtitle: "Compliance, soportes y declaraciones",
    eyebrow: "Validación final",
    icon: ShieldCheck,
  },
];

export const STATUS_CONFIG: Record<
  string,
  { label: string; badge: string; title: string; text: string }
> = {
  submitted: {
    label: "Solicitud recibida",
    badge: "Proceso recibido",
    title: "Todo listo",
    text: "Hemos recibido tu información. Nuestro equipo operativo revisará los documentos y te contactaremos pronto para activar tu recaudo.",
  },
  created: {
    label: "Cuenta creada",
    badge: "Cuenta creada",
    title: "Activado",
    text: "Tu cuenta ha sido activada. Ya puedes empezar a recibir pagos.",
  },
  cancelled: {
    label: "Solicitud cancelada",
    badge: "Solicitud cancelada",
    title: "Cancelada",
    text: "Esta solicitud fue cancelada y ya no está disponible para edición.",
  },
};

export const EYEBROW_COLORS: Record<
  number,
  { border: string; bg: string; color: string }
> = {
  1: { border: "palomma.200", bg: "palomma.50", color: "palomma.700" },
  2: { border: "blue.200", bg: "blue.50", color: "blue.700" },
  3: { border: "palomma.200", bg: "palomma.50", color: "palomma.700" },
  4: { border: "purple.200", bg: "purple.50", color: "purple.700" },
  5: { border: "orange.200", bg: "orange.50", color: "orange.700" },
  6: { border: "teal.200", bg: "teal.50", color: "teal.700" },
};

export const ONBOARDING_LINKS = {
  agregadorVideo: "https://www.youtube.com/",
  gatewayVideo: "https://www.youtube.com/watch?v=svy4cGdpfng",
  psePortal: "https://ui.pse.com.co/ui/",
  whatsappSupport: "https://wa.me/573126202787",
  palommaPlus: "https://palomma.com/productos/palomma-plus",
  palommaPlusBenefits: "https://palommaplus.com",
  privacy: "https://palomma.com/legal/privacidad",
  rules:
    "https://docs.google.com/document/d/1YvRetfgqtjdRl7J-kI6QPjRPgQUwaok6fS_ieaKg3w8/edit?usp=sharing",
  terms: "https://palomma.com/legal/terminos",
};

export const surfaceShadow = "0 0 0 1px rgba(0, 0, 0, 0.06)";

export const DOCUMENT_KEYS = [
  "rut",
  "certificacion_bancaria",
  "camara_comercio",
  "logo",
] as const;

export type DocumentKey = (typeof DOCUMENT_KEYS)[number];

export const tipoCuentaCollection = createListCollection({
  items: [
    { label: "Ahorros", value: "savings" },
    { label: "Corriente", value: "checking" },
  ],
});
export const tipoDocumentoTitularCollection = createListCollection({
  items: [
    { label: "NIT", value: "nit" },
    { label: "Cédula de ciudadanía", value: "cc" },
  ],
});
